<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">

        <img src="/assets/img/logo.png"/>

        <div class="card-group mb-4">
          <div class="card p-4">
            <div class="card-body">

              <div class="col-md-12 m-a-12">

                <div class="animated fadeIn">

                  <div class="row">

                    <div class="col-md-12 m-a-12">

                      <h2>Reset password</h2>

                      <span style="color: red">{{errorMessage}}</span>
                      <span style="color: green">{{infoMessage}}</span>

                      <br/><br/>
                      <div class="card" *ngIf="!_successful">
                        <div class="card-body">
                          <form action="" method="post">


                            <div class="form-group">
                              <label for="nf-password">New password</label>
                              <input type="password" id="nf-password" name="nf-password"
                                     [(ngModel)]="model.newPassword" class="form-control" placeholder="Enter Password..">
                            </div>


                            <div class="form-group">
                              <label for="nf-password">Confirm new Password</label>
                              <input type="password" id="nf-confirm-password" name="nf-confirm-password"
                                     [(ngModel)]="model.confirmPassword" class="form-control" placeholder="Enter Password..">
                            </div>
                          </form>
                        </div>
                        <div class="card-footer">
                          <button type="submit" class="btn btn-sm btn-primary" (click)="submit()" required><i class="fa fa-dot-circle-o"></i> Submit</button>
                          <button type="reset" class="btn btn-sm btn-danger"><i class="fa fa-ban"></i> Reset</button>
                        </div>

                      </div>
                      <br/>
                      <button type="button" class="btn btn-link px-0" onclick="history.go(-1)">&lt; Back</button>
                    </div>


                  </div>
                </div>

              </div>
            </div>



          </div>
        </div>
      </div>


    </div>
  </div>
</div>
